import PropTypes from 'prop-types';
import React from 'react';

import useProductBrand from '../../hooks/use_product_brand';
import useTranslation from '../../hooks/use_translation';
import ReadMoreLink from '../framework/read-more-link';
import AffiliateIcon from '../framework/svgs/icons/affiliate-icon';
import Trans from '../translation/trans';

const ProductBrandBadge = ({
	color = 'light',
	product_brand_id,
	size = 'sm',
}) => {
	const { t } = useTranslation('component_shop_product_brand_badge');

	const sizeList = {
		lg: 'lead',
		md: 'base',
		sm: 'small',
		xs: 'list-subtitle',
		xxs: 'xxs',
	};

	const colors = {
		dark: 'text-white border-light',
		light: 'text-dark border-dark',
	};

	const { items: product_brands } = useProductBrand({
		include_product_brands: [product_brand_id],
	});

	const product_brand = product_brands?.length ? product_brands[0] : null;
	if (!product_brand) return <></>;

	const product_brand_variant = product_brand?.product_brand_variant;

	return (
		<>
			<span
				aria-controls="affiliate-offcanvas"
				className={`${sizeList[size]} product-badge ${colors[color]}`}
				data-bs-target={`#affiliate-offcanvas`}
				data-bs-toggle="offcanvas"
				role="button"
			>
				<AffiliateIcon /> {product_brand_variant?.title}
			</span>
			<div
				aria-labelledby="affiliate-label"
				className="offcanvas offcanvas-end"
				id="affiliate-offcanvas"
			>
				<div className="offcanvas-header">
					<h5 id="affiliate-label">{product_brand_variant?.title}</h5>
					<button
						aria-label="Close"
						className="btn-close text-reset"
						data-bs-dismiss="offcanvas"
						type="button"
					></button>
				</div>
				<div className="offcanvas-body">
					<Trans defaults={product_brand_variant?.excerpt} t={t} />

					<ReadMoreLink
						label={t('t2')}
						page="varumarken"
						product_brand_id={product_brand_id}
					/>

					<div className="alert alert-warning border-0 small mt-3">
						<Trans i18nKey="t1" t={t} />
					</div>
				</div>
			</div>
		</>
	);
};

ProductBrandBadge.propTypes = {
	color: PropTypes.string,
	product_brand_id: PropTypes.string,
	size: PropTypes.string,
};

export default ProductBrandBadge;
